import { ApiConnector, GET } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/roles');
    return {
        RolesList: async data => await API(GET, '', false).call(data),
        PermissionsList: async query => await API(GET, '/permission', false, query).call(),
    };
})();
